var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAviso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aviso") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Home_Pesquisa",
    transform: "translate(-1578.000000, -11263.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy",
    transform: "translate(986.000000, 10975.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M596.152001,303.992033 C593.375609,303.992033 592.215445,302.0162 593.559635,299.602178 L596.055988,295.124685 L598.40832,290.918072 C599.832521,288.360643 602.168852,288.360643 603.593053,290.918072 L605.945386,295.132652 L608.441738,299.610145 C609.785928,302.024167 608.617763,304 605.849372,304 L601.000687,304 L601.000687,303.992033 L596.152001,303.992033 Z M601.000642,294.104877 L601.000642,298.088411 M600.996247,300.478532 L601.096247,300.478532",
    id: "aviso"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviso);
export default __webpack_public_path__ + "static/media/aviso.3b0f0c79b8f9abc42fa02d135fab7e35.svg";
export { ForwardRef as ReactComponent };